export const DATA_SET = "appEnv.DATA_SET";
export const MOBILE_SET = "appEnv.MOBILE_SET";
export const DIMENSIONS_SET = "appEnv.DIMENSIONS_SET";
